import { useEffect } from 'react'

import { isSingleItemArray, isValidArray, tr } from 'mmfintech-commons'

import PaymentMethodButton from '../PaymentMethodButton'

import type { PaymentOptionResponse } from 'mmfintech-checkout-commons/types'

import './selectMethod.scss'

interface SelectMethodProps {
  paymentOptions: PaymentOptionResponse[]
  method: string
  setMethod: (method: string) => void
  onContinue?: () => void
  errorVisible: boolean
  disabled?: boolean
}

const SelectMethod = (props: SelectMethodProps) => {
  const { paymentOptions, method, setMethod, onContinue, errorVisible, disabled } = props

  useEffect(() => {
    if (
      isSingleItemArray<PaymentOptionResponse[]>(paymentOptions) &&
      (!method || method !== paymentOptions[0].paymentMethod)
    ) {
      setMethod(paymentOptions[0].paymentMethod)
    }
  }, [paymentOptions, method, setMethod])

  return isValidArray<PaymentOptionResponse[]>(paymentOptions) ? (
    <div className='select-method-pane-wrapper'>
      <div className='select-method-title'>{tr('CHECKOUT.PAYMENT.METHOD_LABEL', 'Payment method')}</div>
      <div className='select-method-content'>
        {paymentOptions.map((option, index) => (
          <PaymentMethodButton
            key={`${option.paymentMethod}-${index}`}
            name={option.paymentMethod}
            disabled={disabled}
            selected={option.paymentMethod === method}
            onClick={() => setMethod(option.paymentMethod)}
            onContinue={onContinue}
          />
        ))}
      </div>
    </div>
  ) : errorVisible ? (
    <div className='select-method-pane-wrapper'>
      <div className='select-method-empty' data-test='no-methods-error'>
        {tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}
      </div>
    </div>
  ) : null
}

export default SelectMethod
